import Swiper, { Autoplay, Navigation, Pagination, Lazy } from 'swiper';

Swiper.use([Autoplay, Navigation, Pagination, Lazy]);

const swiper = new Swiper('.swiper', {
  loop: true,
  
  autoplay: {
    delay: 4000
  },
  
  lazy: true, // enable lazy loading of images
  
  preloadImages: true, // preload all images before the slider is initialized
  
  // set appropriate breakpoints for responsive images
  // breakpoints: {
  //   640: {
  //     width: 640,
  //     height: 360,
  //   },
  //   768: {
  //     width: 768,
  //     height: 432,
  //   },
  //   1024: {
  //     width: 1024,
  //     height: 576,
  //   },
  //   1280: {
  //     width: 1280,
  //     height: 720,
  //   },
  //   1440: {
  //     width: 1440,
  //     height: 810,
  //   },
  //   1600: {
  //     width: 1600,
  //     height: 900,
  //   }
  // }
});

// ensure that the images are cached by setting appropriate Cache-Control headers
const images = document.querySelectorAll('.swiper-lazy');
for (let i = 0; i < images.length; i++) {
  const img = images[i];
  img.setAttribute('loading', 'lazy'); // set loading attribute to lazy
  img.setAttribute('decoding', 'async'); // set decoding attribute to async
  img.setAttribute('srcset', img.getAttribute('data-srcset')); // set the srcset attribute to the data-srcset attribute
  img.setAttribute('sizes', img.getAttribute('data-sizes')); // set the sizes attribute to the data-sizes attribute
}


function setMainSliderMargin() {
  let header = document.querySelector("header");
  let headerHeight = header.height;
  if (header) {
    if (swiper) {
      swiper.style.marginTop = headerHeight + "px";
    }
  }
  
  let width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

  if (width > 1080 && document.querySelector(".dashboard-link") !== null) {
    $(".dashboard-link").css("display", "block");
    $("#menu-list").css("display", "block");
    $("#user-menu-list").css("display", "block");
    $("#menu-icon-list").css("display", "inline-flex");
  } else {
    $(".dashboard-link").css("display", "none");
  }
}

window.addEventListener("turbo:load", event => {
  console.log("we here")
  setMainSliderMargin();
  window.onresize = setMainSliderMargin;
});


let BurgerIcon = document.querySelector(".burger-icon");

if (BurgerIcon) {
  BurgerIcon.addEventListener("click", e => {
    let PreviousSibling = e.target.previousElementSibling;
    PreviousSibling.classList.toggle("active");
  });
}
